import React, { useEffect, useRef, useState } from 'react'
import { useFormValidator } from '../../effects/forms/useFormValidator'
import { ISwimlaneView } from './ControlSwimlane'

/**
 * Property types for edit swimlane component
 */
export interface IEditSwimlaneProps {
    swimlane: ISwimlaneView
    onCancel: () => void
    onSave: (swimlane: ISwimlaneView) => void
}

/**
 * React component for editing swimlanes
 * @param props
 */
function EditSwimlaneComponent(props: IEditSwimlaneProps) {
    const nameInput = useRef<HTMLInputElement>(null)

    const [name, setName] = useState(props.swimlane.name)
    const validator = useFormValidator()

    useEffect(() => {
        if (nameInput && nameInput.current) nameInput.current.focus()
    }, [name])

    return (
        <form
            data-testid="editswimlane-form"
            noValidate
            onSubmit={(event) =>
                validator.handleSubmit(event, () =>
                    props.onSave({ ...props.swimlane, name: name })
                )
            }
            className={`card mb-2 ${validator.valid ? '' : 'was-validated'}`}>
            <div className="card-header">
                <div className="form-group">
                    <label htmlFor="edit-swimlane-name">Name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="edit-swimlane-name"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        minLength={2}
                        required
                        ref={nameInput}></input>
                    <div
                        className="invalid-feedback"
                        aria-label="name input error feedback">
                        Please provide a name which is at least 2 character long
                    </div>
                </div>
            </div>
            <div className="card-body">
                <button
                    type="button"
                    className="btn btn-secondary mr-1 btn-outline"
                    onClick={props.onCancel}>
                    Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                    Save
                </button>
            </div>
        </form>
    )
}
export default EditSwimlaneComponent
